<app-header [forceLightBackground]="true"></app-header>
<div class="provider-my-projects">
  <div class="provider-my-projects--layout">
    <app-provider-sidebar class="provider-my-projects--sidebar"></app-provider-sidebar>
    <div class="provider-my-projects--content">
      <app-page-header></app-page-header>
      <app-my-project></app-my-project>
    </div>
  </div>
</div>
